export default {
  title: '礼品列表',
  addGift: '添加礼品',
  editGift: '编辑礼品',
  giftName: '礼品名称',
  giftNo: '礼品编号',
  giftType: '礼品类型',
  giftCategory: '礼品分类',
  virtualGift: '虚拟礼品',
  physicalGift: '实物礼品',
  id: 'ID',
  giftInfo: '礼品信息',
  giftPrice: '礼品价格',
  giftSpec: '礼品规格',
  detail: '详情',
  singleSpec: '单规格',
  multiSpec: '多规格',
};
